module.exports = __webpack_public_path__ + "img/logo-k.57b0cc11.png";